<template>
    <div class="flex md:hidden">
        <div
            v-for="(tabLabel, tabKey) in tabOptions"
            @click="setCurrentTab(tabKey)"
            :class="
                'mx-2 border-b-[3px] border-b-transparent p-1 px-0 text-[16px] font-semibold first-of-type:ml-0 last-of-type:mr-0 hover:cursor-pointer hover:text-primary-625' +
                ' ' +
                (tabKey == selectedTab
                    ? '!border-b-primary-525 text-primary-525'
                    : 'text-gray-625')
            "
        >
            {{ tabLabel }}
        </div>
    </div>
</template>
<script>
export default {
    name: "MobileTabSelector",
    props: {
        currentTab: {
            type: String,
            default: "",
        },
        tabOptions: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            selectedTab: this.currentTab ?? this.tabOptions[0],
        };
    },
    methods: {
        setCurrentTab(tabKey) {
            this.selectedTab = tabKey;
            this.$emit("tab-selected", tabKey);
        },
    },
};
</script>
